module.exports = __webpack_public_path__ + "img/1275907518.a470340d.jpg";